import React, { useState, useEffect} from "react";
import promoteartistimg1 from './../../../../images/promoteartistimg1.png'
import promoteartistimg2 from './../../../../images/promoteartistimg2.png'
import promoteartistimg4 from './../../../../images/promoteartistimg4.png'
import promoteartistimg5 from './../../../../images/promoteartistimg5.png'
import promoteartistimg7 from './../../../../images/promoteartistimg7.jpg'
import promoteartistimg8 from './../../../../images/promoteartistimg8.png'
import promoteartistimg9 from './../../../../images/promoteartistimg9.jpg'
import promoteartistimg10 from './../../../../images/promoteartistimg10.png'
import promoteartistimg11 from './../../../../images/promoteartistimg11.png'
import promoteartistimg12 from './../../../../images/promoteartistimg12.png'
import promoteartistimg13 from './../../../../images/promoteartistimg13.png'
import promoteartistimg14 from './../../../../images/promoteartistimg14.png'
import promoteartistprotag from './../../../../images/promoteartistprotag.png'
import jppromoteartistprotag from './../../../../images/jp-promoteartistprotag.png'
import albumexampleimage2 from './../../../../images/albumexampleimg2.png'
import roundbackbtn from './../../../../images/roundbackicon.png'
import getverifiedpopupimg from './../../../../images/getverifiedpopupimg.png'
import crossicon from './../../../../images/crossicon.png'
import purplebackicon from  './../../../../images/purplebackicon.png'
import YoutubeMonetize from "../YoutubeMonetize/YoutubeMonetize";
import VerifiedArtist from "./VerifiedArtist";
import LyricVideo from "./LyricVideo";
import requestsubmittedicon from './../../../../images/requestsubmittedicon.png'
import './PromoteYourself.css'
import ReactModal from 'react-modal';
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';

import lyricvidborder from './../../../../images/lyricvidborder.png'
import lyricvid1 from './../../../../images/lyricvid1.png'
import lyricvid2 from './../../../../images/lyricvid2.png'
import lyricvid3 from './../../../../images/lyricvid3.png'
import lyricvid4 from './../../../../images/lyricvid4.png'
import lyricvid5 from './../../../../images/lyricvid5.png'
import lyricvid6 from './../../../../images/lyricvid6.png'
import lyricplayvid from './../../../../images/lyricplayvid.png'
import lyricviddots from './../../../../images/lyricviddots.png'
import lyricvidprice1 from './../../../../images/lyricvidprice1.png'
import lyricvidprice2 from './../../../../images/lyricvidprice2.png'
import lyricvidprice3 from './../../../../images/lyricvidprice3.png'
import lyricvidprice4 from './../../../../images/lyricvidprice4.png'
import lyricvidcusprice1 from './../../../../images/lyricvidcusprice1.png'
import lyricvidcusprice2 from './../../../../images/lyricvidcusprice2.png'
import lyricvidcusprice3 from './../../../../images/lyricvidcusprice3.png'
import Select from 'react-select'
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import backbtn from './../../../../images/backicon.png'
import WorldCollection from "./WorldCollection";
import {useLocation,useNavigate} from "react-router-dom";
import {Route,Routes, Redirect, Navigate,BrowserRouter as Router} from 'react-router-dom'
import { useJwt, decodeToken } from "react-jwt";

function PromoteYourselfMenu({hidedashboard}) {
    const [menuOption,setMenuOption] = useState('All')
    const [PSPopup1,setPSPopup1] = useState(false)
    const [PSPopup2,setPSPopup2] = useState(false)
    const [PSPopup3,setPSPopup3] = useState(false)
    const [PSPopup4,setPSPopup4] = useState(false)
    const [RSPopup,setRSPopup] = useState(false)
    const [VAPopup1,setVAPopup1] = useState(false)
    const [VAPopup2,setVAPopup2] = useState(false)
    const [VAPopup3,setVAPopup3] = useState(false)
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const [isYMonetize,setIsYMonetize] = useState(false);
    const [isWorldCollection,setIsWorldCollection] = useState(false);
    const [isVArtist,setVArtist] = useState(false);
    const [timeLeft, setTimeLeft] = useState(null);
    const [counter, setCounter] = React.useState(5);
    const {t, i18n } = useTranslation();
    const cookies = new Cookies(null ,{ path: '/' });
    const navigate = useNavigate();

    const [booknow,setBookNow] = useState(false)
    const [name,setName] = useState("")
    const [email,setEmail] = useState("")
    const [projectName,setProjectName] = useState("")
    const [projectNotes,setProjectNotes] = useState("")
    const [quotecheckbox,setQuoteCheckBox] = useState(false)
    const [hearaboutus,setHearAboutUs] = useState("")

    const [LyricVideo,setLyricVideo] = useState(false)

    const hearAboutUsOptions = [{ value: 'Instagram', label: 'Instagram' },
    { value: 'Blogpost', label: 'Blogpost' },
    { value: 'Email', label: 'Email' }]

    const changehearAboutUsOptions = value => {
        setHearAboutUs(value)
    }

    const ToggleWorlds = (data) =>{
      setIsWorldCollection(data)
    }

    
    const ToggleYTMonetize = (data) =>{
      setIsYMonetize(data)
    }

    function topFunction() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  


  useEffect(() => {
    // exit early when we reach 0
    if (!timeLeft) return;

    if(timeLeft===1){
      console.log("TIME LEFT IS 1");
      setPSPopup3(true)
      setPSPopup4(false)
      setVAPopup3(false)
    }

    if(timeLeft===0){
       console.log("TIME LEFT IS 0");
       setTimeLeft(null)
       setPSPopup3(true)
    }

    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {

      setTimeLeft(timeLeft - 1);
    }, 1000);

    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
    // add timeLeft as a dependency to re-rerun the effect
    // when we update it
  }, [timeLeft]); 

  useEffect(()=>{
    topFunction()
  },[])

  const startTimer = ()=>{
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }

  const TrackcolourStyles = {
    control: styles => ({ ...styles,  borderColor: '#636468',
    backgroundColor:'rgba(0,0,0,16%)',
    width: '34.187em',
    height: '3em',
    borderRadius:'4px',
    color:'rgba(255, 255, 255, 1)',
    marginTop:'1.2em',
   
  }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor:'#18191F' ,
        color:'rgba(255, 255, 255, 1)',
        cursor: isDisabled ? 'not-allowed' : 'default',
        marginTop:'-0.3em',
        marginBottom:'-0.3em'
      };
    },
    input: (styles) => ( {...styles , 
                            FontFamily:'ClashGrotesk-Variable,sans-serif',
                            FontSize:'1rem',
                            FontWeight: 'medium',
                            LineHeight: '150%',
                            LetterSpacing: '0%',
                            color:'rgba(255, 255, 255, 1)'}),
    singleValue : (styles) => ({ ...styles, 
                                    color:'rgba(255, 255, 255, 1)',
                                    FontFamily:'ClashGrotesk-Variable,sans-serif',
                                    FontSize:'1rem',
                                    FontWeight: 'medium',
                                    LineHeight: '150%',
                                    LetterSpacing: '0%'})
  };

  function closePSPopup1(){
    setPSPopup1(false)
  }

  function closePSPopup2(){
    setPSPopup2(false)
  }

  function closePSPopup4(){
    setPSPopup4(false)
  }

  function closePSPopup3(){
    setPSPopup3(false)
  }

    return (
      <div style={{display:'flex',flexDirection:'column',alignItems:'center',minHeight:'100vh',height:'auto',paddingBottom:'5em'}}>
      <div className="PromoteYourselfHeader">{t('PromoteyourselfHeader')}</div>
      <div className="HeaderContainer">
          <div className="HeaderTitleTxt"> <Trans i18nKey="Toolstoamplifyyourmusic" components={{1:<br/>}} >
          Tools to Amplify Your Music Career
              </Trans></div>
          <div className="HeaderDescTxt">
          <Trans i18nKey="Nerveprosuiteafull" components={{1:<br/>}} >
          N3RVE Pro Suite: A Full Spectrum of Creative, Marketing, and Promotion Tools Tailored for Career Growth.
              </Trans></div>
      </div>

      <div style={{display:'flex',flexDirection:'row',width:'92%',marginTop:'1em',marginBottom:'1em',marginLeft:'-1.5em'}}>
          {
          menuOption === "All" &&
          <div className="SelectedIcon" onClick={()=>setMenuOption("All")}>
            {t('Allp')}
          </div>
          }

        {
          menuOption !== "All" &&
          <div className="UnSelectedIcon" onClick={()=>setMenuOption("All")}>
            {t('Allp')}
          </div>
          }

        {
          menuOption !== "Promotional" &&
          <div className="UnSelectedIcon" onClick={()=>setMenuOption("Promotional")}>
              {t('Promotionalp')}
          </div>
          }

        {
          menuOption === "Promotional" &&
          <div className="SelectedIcon" onClick={()=>setMenuOption("Promotional")}>
          {t('Promotionalp')}
          </div>
          }

        {
          menuOption === "Creative" &&
          <div className="SelectedIcon" onClick={()=>setMenuOption("Creative")}>
            {t('Creativep')}
          </div>
          }

        {
          menuOption !== "Creative" &&
          <div className="UnSelectedIcon" onClick={()=>setMenuOption("Creative")}>
              {t('Creativep')}
          </div>
          }

        {
          menuOption === "Hire Professinal" &&
          <div className="SelectedIcon" onClick={()=>setMenuOption("Hire Professinal")}>
            {t('Hireprofessinalp')} 
          </div>
          }

        {
          menuOption !== "Hire Professinal" &&
          <div className="UnSelectedIcon" onClick={()=>setMenuOption("Hire Professinal")}>
            {t('Hireprofessinalp')} 
          </div>
          }

        {
          menuOption === "AI" &&
          <div className="SelectedIcon" onClick={()=>setMenuOption("AI")}>
            AI
          </div>
          }

        {
          menuOption !== "AI" &&
          <div className="UnSelectedIcon" onClick={()=>setMenuOption("AI")}>
            AI
          </div>
          }

      </div>

      <div style={{display:'flex',flexDirection:'column',width:'100%',alignItems:'center'}}>

          {
          (menuOption==="All" || menuOption==="Promotional") &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
              style={{backgroundImage:`url(${promoteartistimg1})`}}
              // src={promoteartistimg1}
              />
            <div className="ListItemStats">
                <div className="ListItemHeader">
                Get "Verified Artist" Status
                </div>
                <div className="ListItemDesc">
                {t('Getverifiedonspotify')} 
                </div>

                <div className="ListItemBtn" onClick={()=>{ topFunction();
                 if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                  navigate("/Dashboard/promoteyourself/verifiedartist")
               }

              if(decodeToken(cookies.get('token')).info.role==="label"){
                  navigate("/dashboard/label/promoteartist/verifiedartist")
              }
                  }}>
                {t('Getstartedp')} 
                </div>
            </div>
          </div>

          }

        {
          (menuOption==="All" || menuOption==="Promotional") &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
                style={{backgroundImage:`url(${promoteartistimg2})`}}
                //  src={promoteartistimg2}
                />
            <div className="ListItemStats">
                <div className="ListItemHeader">
                {t('Generatepresavelink')}  
                </div>
                <div className="ListItemDesc">
                {t('Elevateyourbrandwithcustom')} 
                </div>

                <div className="ListItemBtn" onClick={()=>setPSPopup1(true)}>
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }

      {
          (menuOption==="All" || menuOption==="Promotional" || menuOption==="Hire Professinal") &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
            style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/nb8kk4ztccbek4qfohx7")`}}
            //  src={promoteartistimg3}
            />
            <div className="ListItemStats">
                <div className="ListItemHeader">
                {t('Marketingpoweredbynexd')}  
                </div>
                <div className="ListItemDesc">
                {t('Loremloremipsumdolor')}  
                </div>

                <div className="ListItemBtn">
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }   

          {
          (menuOption==="All" || menuOption==="Promotional" || menuOption==="Hire Professinal" ||  menuOption==="Creative" ) &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
              style={{backgroundImage:`url(${promoteartistimg4})`}}
              // src={promoteartistimg4}
              />
            <div className="ListItemStats">
                <div className="ListItemHeader">
                {t('Createmusicvideopowered')}  
                </div>
                <div className="ListItemDesc">
                {t('Bringyourmusictolife')}  
                </div>

                <div className="ListItemBtn" onClick={()=>{topFunction();
                 if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                  navigate("/Dashboard/promoteyourself/lyricvideo")
                }

                if(decodeToken(cookies.get('token')).info.role==="label"){
                  navigate("/dashboard/label/promoteartist/lyricvideo")
                }
                  }}>
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }     

          
        {/* {
          (menuOption==="All" || menuOption==="Promotional" || menuOption==="Hire Professinal" ||  menuOption==="Creative" ) &&
          <div className="ListItemContainer">
            
            <img className="ListItemImage" src={promoteartistimg5}/>
            <div className="ListItemStats">
              <div className="ListItemHeader">
              {t('Createbrandedswags')}  
                </div>
                
                <div className="ListItemDesc">
                {t('Elevateyourbrandwithcustomartist')}  
                </div>

                <div className="ListItemBtn">
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }   */}

      {
          (menuOption==="All" || menuOption==="Creative" || menuOption==="AI") &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
              style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/jxc8phouk1mgoabfzugm")`}}
              // src={promoteartistimg6}
              />
            <div className="ListItemStats">
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                  <div className="ListItemHeader">
                  {t('R3naiassistant')} <span className="comingsoonTxt">[coming soon]</span>
                  </div>
                  
                  {
                    cookies.get('lang') === 'en' &&
                    <img className="Protag" src={promoteartistprotag} />
                  }
                  {
                    cookies.get('lang') === 'jp' &&
                    <img className="Protag" src={jppromoteartistprotag} />
                  }
                  
                </div>

                <div className="ListItemDesc">
                {t('Unlockthefullpotentialof')} 
                </div>

                <div className="ListItemBtn">
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }  

        {
          (menuOption==="All" || menuOption==="Creative" || menuOption==="AI") &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
            style={{backgroundImage:`url(${promoteartistimg7})`}}
            //  src={promoteartistimg7}
            />
            <div className="ListItemStats">
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                  <div className="ListItemHeader">
                  {t('AIcoverartbuilder')} <span className="comingsoonTxt">[coming soon]</span>
                  </div>
                  {
                    cookies.get('lang') === 'en' &&
                    <img className="Protag" src={promoteartistprotag} />
                  }
                  {
                    cookies.get('lang') === 'jp' &&
                    <img className="Protag" src={jppromoteartistprotag} />
                  }
                </div>

                <div className="ListItemDesc">
                {t('Designcaptivatingalbumcover')} 
                </div>

                <div className="ListItemBtn">
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }  

      {/* {
          (menuOption==="All" || menuOption==="Creative" || menuOption==="Hire Professinal" || menuOption==="AI") &&
          <div className="ListItemContainer">
            <img className="ListItemImage" src={promoteartistimg8}/>
            <div className="ListItemStats">

            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                  <div className="ListItemHeader">
                  {t('Logodesigner')} 
                  </div>
                  {
                    cookies.get('lang') === 'en' &&
                    <img className="Protag" src={promoteartistprotag} />
                  }
                  {
                    cookies.get('lang') === 'jp' &&
                    <img className="Protag" src={jppromoteartistprotag} />
                  }
                </div>
              
                <div className="ListItemDesc">
                {t('Unlockthefullpotentialofyourmusic')}
                </div>

                <div className="ListItemBtn">
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }   */}
          
          {
          (menuOption==="All" ) &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
              style={{backgroundImage:`url(${promoteartistimg9})`}}
            //  src={promoteartistimg9}
            />
            <div className="ListItemStats">
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                  <span className="ListItemHeader">
                  <Trans i18nKey="Getyourvideofeatured" components={{1:<br/>}} >
                  Get Your Video Featured on CakeWalk 
                  </Trans>
                  &nbsp; <span className="comingsoonTxt">[coming soon]</span>
                  </span>
                  {
                    cookies.get('lang') === 'en' &&
                    <img className="Protag" src={promoteartistprotag} />
                  }
                  {
                    cookies.get('lang') === 'jp' &&
                    <img className="Protag" src={jppromoteartistprotag} />
                  }
                </div>
            
                <div className="ListItemDesc">
                {t('Showcaseyourmusictoawider')}  
                </div>

                <div className="ListItemBtn">
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }  

        {
          (menuOption==="All" || menuOption==="Hire Professinal") &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
              style={{backgroundImage:`url(${promoteartistimg10})`}}
              // src={promoteartistimg10}
              />
            <div className="ListItemStats">
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                  <div className="ListItemHeader">
                  {t('Businessmanagement')}  <span className="comingsoonTxt">[coming soon]</span>
                  </div>
                  {
                    cookies.get('lang') === 'en' &&
                    <img className="Protag" src={promoteartistprotag} />
                  }
                  {
                    cookies.get('lang') === 'jp' &&
                    <img className="Protag" src={jppromoteartistprotag} />
                  }
                </div>
              
                <div className="ListItemDesc">
                {t('Navigatethecomplexitiesofthemusic')}  
                </div>

                <div className="ListItemBtn">
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }  

        {
          (menuOption==="All" || menuOption==="Hire Professinal") &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
              style={{backgroundImage:`url(${promoteartistimg11})`}}
            //  src={promoteartistimg11}
            />
            <div className="ListItemStats">
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                  <div className="ListItemHeader">
                  {t('Legalservices')}  <span className="comingsoonTxt">[coming soon]</span>
                  </div>
                  {
                    cookies.get('lang') === 'en' &&
                    <img className="Protag" src={promoteartistprotag} />
                  }
                  {
                    cookies.get('lang') === 'jp' &&
                    <img className="Protag" src={jppromoteartistprotag} />
                  }
                </div>

                <div className="ListItemDesc">
                {t('Secureyourartisticcreations')}  
                </div>

                <div className="ListItemBtn">
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }  

        {
          (menuOption==="All" || menuOption==="Hire Professinal") &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
              style={{backgroundImage:`url(${promoteartistimg12})`}}
            //  src={promoteartistimg12}
            />
            <div className="ListItemStats">
              <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                  <div className="ListItemHeader">
                  {t('Youtubemonetization')}
                  </div>
                  {
                    cookies.get('lang') === 'en' &&
                    <img className="Protag" src={promoteartistprotag} />
                  }
                  {
                    cookies.get('lang') === 'jp' &&
                    <img className="Protag" src={jppromoteartistprotag} />
                  }
                </div>
                
                <div className="ListItemDesc">
                {t('Maximizeyouryoutubeearnings')}
                </div>

                <div className="ListItemBtn" onClick={()=>{
                   if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                    navigate("/Dashboard/promoteyourself/youtubemonetize")
                  }
  
                  if(decodeToken(cookies.get('token')).info.role==="label"){
                    navigate("/dashboard/label/promoteartist/youtubemonetize")
                  }}}>
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }  

        {
          (menuOption==="All" || menuOption==="Hire Professinal") &&
          <div className="ListItemContainer">
            <div className="ListItemImage" 
            style={{backgroundImage:`url(${promoteartistimg13})`}}
            //  src={promoteartistimg13}
            />
            <div className="ListItemStats">
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                  <span className="ListItemHeader">
                  {t('Worldcollection')} 
                  </span>
                  {
                    cookies.get('lang') === 'en' &&
                    <img className="Protag" src={promoteartistprotag} />
                  }
                  {
                    cookies.get('lang') === 'jp' &&
                    <img className="Protag" src={jppromoteartistprotag} />
                  }
                </div>
                
                <div className="ListItemDesc">
                {t('Loremloremipsumdolor')}  
                </div>

                
                <div className="ListItemBtn" onClick={()=>{topFunction();
                 if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                  navigate("/Dashboard/promoteyourself/worldcollection")
                }

                if(decodeToken(cookies.get('token')).info.role==="label"){
                  navigate("/dashboard/label/promoteartist/worldcollection")
                }
                  }}>
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }  

        {/* {
          (menuOption==="All" || menuOption==="Creative" || menuOption==="AI") &&
          <div className="ListItemContainer">
            <img className="ListItemImage" src={promoteartistimg14}/>
            <div className="ListItemStats">
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                  <div className="ListItemHeader">
                  Music Video Builder (AI)
                  </div>
                  <img className="Protag" src={promoteartistprotag} />
                </div>
              
                <div className="ListItemDesc">
                Produce mesmerizing music videos with our advanced AI technology, turning your musical vision into a visual masterpiece with ease.
                </div>

                <div className="ListItemBtn">
                {t('Getstartedp')} 
                </div>
            </div>
          </div>
          
          }   */}


      </div>

      <ReactModal
                isOpen={PSPopup1}
                contentLabel="Example Modal"
                className="PresavePopup1Container"
                overlayClassName="Overlay"
                onRequestClose={closePSPopup1} // closes the modal when the user presses the escape key
                shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                >
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/c1186unxrt2tb3fetgof"} style={{width:'35em',height:'21.125em',marginTop:'-0em'}}/>
                <img src={crossicon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setPSPopup1(false)}/>
                
                <div className="PresavePopup1Header">
                {t('Requestpresavelinkpop')} 
                </div>
      
                <div className="PresavePopup1InfoContainer">
                  <div className="PresavePopup1InfoHeader">{t('Whatsapresavelink')}</div>
                  <div className="PresavePopup1Info1">{t('Apresavelinkallowsyourfans')}</div>
                </div>
      
                <div className="PresavePopup1Info2">
                {t('Elevateyourbrandwithcustomartistswag')}
                </div>
      
                <div className="PresavePopup1ContinueBtn" onClick={()=>{setPSPopup2(true);setPSPopup1(false)}} style={{cursor:'pointer'}}>
                  {t('Continue')}
                  <div className="PostLoginBtnOverlay"/>
                </div>
      
                </ReactModal>
      
                <ReactModal
                isOpen={PSPopup2}
                contentLabel="Example Modal"
                className="PresavePopup2Container"
                overlayClassName="Overlay"
                onRequestClose={closePSPopup2} // closes the modal when the user presses the escape key
                shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                >
                <img src={crossicon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setPSPopup2(false)}/>
                
                <div className="PresavePopup2Header">
                {t('Requestpresavelinkpop')} 
                </div>
      
      
                <div className="PresavePopup2Info1">
                {t('Chooseareleaseforwhich')} 
                </div>

                {
                  !isChecked1 &&
                  <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',width:'85%',borderRadius:'8px'}}>
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dkyvvtdtsyctuil9zpbj"} style={{width:'6.25em',height:'6.25em',marginLeft:'1.5em',marginTop:'0.75em',marginBottom:'0.75em',marginRight:'0.68em'}}/>
      
                          <div style={{display:'flex',flexDirection:'column'}}>
                            <div className="PopupAlbumTxt"> {t('Album')}</div>
                            <div className="PopupAlbumTitle">Vivid Reflection</div>
                            <div className="PopupAlbumTrackNo">3 {t('Tracks')}</div>
                          </div>
                      </div>
                    
                    {/* <input type="checkbox" className="PopupAlbumCheckbox" checked={isChecked}/> */}

                    <Checkbox checked={isChecked1} onChange={()=>{setIsChecked1(!isChecked1);setIsChecked2(false)}}  
                      iconStyle={{fill: '#FFFFFF'}}
                      sx={{
                          [`&, &.${checkboxClasses.checked}`]: {
                              color: '#FFFFFF',
                            },
                          color: "#E91353",
                          '&.Mui-checked': {
                          color: "#E91353"
                          }
                      }}
                      />
      
                </div>

                }

      {
                  isChecked1 &&
                  <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',width:'85%',borderRadius:'8px',backgroundColor:'rgba(233,19,83,50%)'}}>
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dkyvvtdtsyctuil9zpbj"} style={{width:'6.25em',height:'6.25em',marginLeft:'1.5em',marginTop:'0.75em',marginBottom:'0.75em',marginRight:'0.68em'}}/>
      
                          <div style={{display:'flex',flexDirection:'column'}}>
                            <div className="PopupAlbumTxt"> {t('Album')}</div>
                            <div className="PopupAlbumTitle">Vivid Reflection</div>
                            <div className="PopupAlbumTrackNo">3 {t('Tracks')}</div>
                          </div>
                      </div>
                    
                    {/* <input type="checkbox" className="PopupAlbumCheckbox" checked={isChecked}/> */}

                    <Checkbox checked={isChecked1} onChange={()=>{setIsChecked1(!isChecked1);setIsChecked2(false)}}  
                      iconStyle={{fill: '#FFFFFF'}}
                      sx={{
                          [`&, &.${checkboxClasses.checked}`]: {
                              color: '#FFFFFF',
                            },
                          color: "#E91353",
                          '&.Mui-checked': {
                          color: "#E91353"
                          }
                      }}
                      />
      
                </div>

                }
      
      
                
                {/* ,backgroundColor:'#E91353' */}
                {
                  !isChecked2 &&
                  <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',width:'85%',borderRadius:'8px'}}>
                  <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                      <img src={albumexampleimage2} style={{width:'6.25em',height:'6.25em',marginLeft:'1.5em',marginTop:'0.75em',marginBottom:'0.75em',marginRight:'0.68em'}}/>

                      <div style={{display:'flex',flexDirection:'column'}}>
                        <div className="PopupAlbumTxt">{t('Album')}</div>
                        <div className="PopupAlbumTitle">Don't Waste A Minute</div>
                        <div className="PopupAlbumTrackNo">9 {t('Tracks')}</div>
                      </div>
                  </div>
                
                {/* <input type="checkbox" className="PopupAlbumCheckbox" checked={isChecked}/> */}

                <Checkbox checked={isChecked2} onChange={()=>{setIsChecked2(!isChecked2);setIsChecked1(false)}}  
                  iconStyle={{fill: '#FFFFFF'}}
                  sx={{
                      [`&, &.${checkboxClasses.checked}`]: {
                          color: '#FFFFFF',
                        },
                      color: "#E91353",
                      '&.Mui-checked': {
                      color: "#E91353"
                      }
                  }}
                  />

                </div>
                }

          {
                  isChecked2 &&
                  <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',width:'85%',borderRadius:'8px',backgroundColor:'rgba(233,19,83,50%)'}}>
                  <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                      <img src={albumexampleimage2} style={{width:'6.25em',height:'6.25em',marginLeft:'1.5em',marginTop:'0.75em',marginBottom:'0.75em',marginRight:'0.68em'}}/>

                      <div style={{display:'flex',flexDirection:'column'}}>
                        <div className="PopupAlbumTxt">{t('Album')}</div>
                        <div className="PopupAlbumTitle">Don't Waste A Minute</div>
                        <div className="PopupAlbumTrackNo">9 {t('Tracks')}</div>
                      </div>
                  </div>
                
                {/* <input type="checkbox" className="PopupAlbumCheckbox" checked={isChecked}/> */}

                <Checkbox checked={isChecked2} onChange={()=>{setIsChecked2(!isChecked2);setIsChecked1(false)}}  
                  iconStyle={{fill: '#FFFFFF'}}
                  sx={{
                      [`&, &.${checkboxClasses.checked}`]: {
                          color: '#FFFFFF',
                        },
                      color: "#E91353",
                      '&.Mui-checked': {
                      color: "#E91353"
                      }
                  }}
                  />

                </div>

                }
              

      
                <div style={{display:'flex',flexDirection:'row',marginTop:'1.5em'}}>
                  <div className="PresavePopup2CancelBtn" onClick={()=>setPSPopup2(false)}>
                  {t('Cancel')}
                  </div>
      
                  {
                    (isChecked1 || isChecked2) &&
                    <div className="PresavePopup1SubmitBtn" onClick={()=>{setTimeLeft(5);setPSPopup2(false);setPSPopup4(true);}}>
                    {t('Submitrequest')}
                    <div className="PostLoginBtnOverlay"/>
                    </div>
                  }

                  {
                    !isChecked1 && !isChecked2 &&
                    <div className="PresavePopup1SubmitBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                    {t('Submitrequest')}
                    </div>
                  }
                  
                </div>
      
                </ReactModal>

                <ReactModal
                isOpen={PSPopup4}
                contentLabel="Example Modal"
                className="PresavePopup4Container"
                overlayClassName="Overlay"
                onRequestClose={closePSPopup4} // closes the modal when the user presses the escape key
                shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                style={{backgroundColor:'rgba(255,255,255,20%)'}}
                >
                <img src={crossicon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em'}}/>
                
                <div className="PresavePopup2Header">
                {t('Requestpresavelinkpop')} 
                </div>
      
      
                <div className="PresavePopup2Info1">
                {t('Chooseareleaseforwhich')} 
                </div>
      
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',width:'85%',borderRadius:'8px'}}>
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dkyvvtdtsyctuil9zpbj"} style={{width:'6.25em',height:'6.25em',marginLeft:'1.5em',marginTop:'0.75em',marginBottom:'0.75em',marginRight:'0.68em'}}/>
      
                          <div style={{display:'flex',flexDirection:'column'}}>
                            <div className="PopupAlbumTxt">{t('Album')}</div>
                            <div className="PopupAlbumTitle">Vivid Reflection</div>
                            <div className="PopupAlbumTrackNo">3 {t('Tracks')}</div>
                          </div>
                      </div>
                    
                    {/* <input type="checkbox" className="PopupAlbumCheckbox" checked={isChecked}/> */}

                    <Checkbox checked={isChecked1}  
                    disabled
                      iconStyle={{fill: '#FFFFFF'}}
                      sx={{
                          [`&, &.${checkboxClasses.checked}`]: {
                              color: '#FFFFFF',
                            },
                          color: "#E91353",
                          '&.Mui-checked': {
                          color: "#E91353"
                          }
                      }}
                      />
      
                </div>

                {/* ,backgroundColor:'#E91353' */}
      
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',width:'85%',borderRadius:'8px'}}>
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <img src={albumexampleimage2} style={{width:'6.25em',height:'6.25em',marginLeft:'1.5em',marginTop:'0.75em',marginBottom:'0.75em',marginRight:'0.68em'}}/>
      
                          <div style={{display:'flex',flexDirection:'column'}}>
                            <div className="PopupAlbumTxt">{t('Album')}</div>
                            <div className="PopupAlbumTitle">Don't Waste A Minute</div>
                            <div className="PopupAlbumTrackNo">9 {t('Tracks')}</div>
                          </div>
                      </div>
                    
                    {/* <input type="checkbox" className="PopupAlbumCheckbox" checked={isChecked}/> */}

                    <Checkbox checked={isChecked2}
                    disabled
                      iconStyle={{fill: '#FFFFFF'}}
                      sx={{
                          [`&, &.${checkboxClasses.checked}`]: {
                              color: '#FFFFFF',
                            },
                          color: "#E91353",
                          '&.Mui-checked': {
                          color: "#E91353"
                          }
                      }}
                      />
      
                </div>

                <CircularProgress style={{position:'absolute',marginTop:'13em',width:'5em',height:'5em'}} sx={{color:'#FFFFFF'}}/>
      
                <div style={{display:'flex',flexDirection:'row',marginTop:'1.5em'}}>
                  <div className="PresavePopup2CancelBtn" >
                  {t('Cancel')}
                  </div>
      
                  <div className="PresavePopup1SubmitBtn">
                  {t('Submitrequest')}
                  </div>
                </div>
      
                </ReactModal>



                <ReactModal
                isOpen={PSPopup3}
                contentLabel="Example Modal"
                overlayClassName="Overlay"
                className="PresavePopup3Container"
                onRequestClose={closePSPopup3} // closes the modal when the user presses the escape key
                shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                >
                    <img src={requestsubmittedicon} style={{width:'2.62em',height:'2.62em',marginTop:'2em'}}/>
                    <div className="RSPopupHeader"> {t('Requestsubmitted')}</div>
                    <div className="RSPopupInfo">
                    <Trans i18nKey="Wellbeintouchsoon" components={{1:<br/>}} >
                    We'll be in touch soon. <br/>
      Please wait for further details.
                              </Trans></div>
      <div className="PresavePopup1ContinueBtn" onClick={()=>{setPSPopup3(false)}} style={{cursor:'pointer'}}>
                  {t('Donepop')}
                  <div className="PostLoginBtnOverlay"/>
                </div>
                </ReactModal>
              
      </div>
)}

export default  PromoteYourselfMenu;
